import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private http: HttpClient) {
  }

  fetchTree() {
    return this.http.get('/api/help/page/');
  }

  getPage(id: number) {
    return this.http.get(`/api/help/page/detail/${id}/`);
  }

  searchPage(text) {
    return this.http.get(`/api/help/page/detail/?search=${text}`);
  }

}
